// Please don't use or update this service, it will be removed soon.
// Use BusinessDateFormats.js instead.

import Vue from "vue";
import moment from "moment"
import momentTz from "moment-timezone";

export const FORMATS = {
    MONTH_DAY: 'MMM D',
    DAY_MONTH: 'D MMM',
    TIME: 'HH:mm',
    MONTH_YEAR: 'MMM YYYY',
    MONTH_DAY_YEAR: 'MMM D, YYYY',
    DAY_MONTH_YEAR: 'D MMM, YYYY',
}

export const init = (locale) => {
  moment.locale(locale || "en");
}

export const getHourByDateFormat = (time_format) => {
    return time_format === "24h" ? "H:mm" : "h:mma"
}

export const getSimpleDateFormat = (locale) => {
    return locale === "en" ? "MM / DD / YYYY" : "DD / MM / YYYY"
}

export const getSimpleShortDateFormat = (locale) => {
    switch (locale) {
        case "en":
            return 'MMM DD'
        default:
            return 'DD MMM'
    }
}

Vue.filter("dateFormat", (value, format, time_zone = "") => {
    if (!format || !value) return;
    let date = moment(value).utcOffset(time_zone)
    return date.format(format)
});

Vue.filter("dateFormatUTC", (value, format, time_zone = "") => {
    if (!format || !value) return;

    return momentTz.tz(value, time_zone)
        .format(format);
});

export default {
    getHourByDateFormat,
    getSimpleDateFormat,
    getSimpleShortDateFormat,
    FORMATS
}
